import { render, staticRenderFns } from "./SapphireToggle.vue?vue&type=template&id=d43370b8&scoped=true&"
import script from "./SapphireToggle.vue?vue&type=script&lang=js&"
export * from "./SapphireToggle.vue?vue&type=script&lang=js&"
import style0 from "./SapphireToggle.vue?vue&type=style&index=0&id=d43370b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../CommunityWebPortal/_app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d43370b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d43370b8')) {
      api.createRecord('d43370b8', component.options)
    } else {
      api.reload('d43370b8', component.options)
    }
    module.hot.accept("./SapphireToggle.vue?vue&type=template&id=d43370b8&scoped=true&", function () {
      api.rerender('d43370b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "VueCommon/common-components/src/components/SapphireToggle/SapphireToggle.vue"
export default component.exports